window.addEventListener('load', () => {
  window.scrollTo(0, 0);
});
window.addEventListener('DOMContentLoaded', () => {
  const paths = ['/collections/', '/products/', '/cart', '/partners', '/login-landing'];
  const currentPath = window.location.pathname;
  const logoHeader = document.querySelector('.header__heading-logo-wrapper img');
  const innerWidth = window.innerWidth;
  if (currentPath) {
    if (paths.some((path) => currentPath.includes(path))) {
      document.body.classList.add('is-product-matched-path');
      if (logoHeader && innerWidth < 768) {
        logoHeader.src = 'https://cdn.shopify.com/s/files/1/0736/0623/4148/files/VSTU_LOGO_BLACK.svg?v=1754292213';
        logoHeader.srcset = 'https://cdn.shopify.com/s/files/1/0736/0623/4148/files/VSTU_LOGO_BLACK.svg?v=1754292213';
      }
    }
  }
});
